import React from 'react';
import ConfiguracaoPixAutomaticoListPageContainer from './ConfiguracaoPixAutomaticoListPageContainer';

export class ConfiguracaoPixAutomaticoListPage extends React.Component{
    
    render(){
      return (
        <ConfiguracaoPixAutomaticoListPageContainer {...this.props}/>
      )
    }
}
